'use strict';

var regionListByVendor = function regionListByVendor(devEnv) {
    return require('../config/environments/' + devEnv + '.json');
};
var regionListForVendor = function regionListForVendor(devEnv) {
    return function (vendor) {
        return regionListByVendor(devEnv)[vendor];
    };
};

var _require = require('./mappers/azureRegionMapper'),
    cloudStorageValidationAzureRegionList = _require.cloudStorageValidationAzureRegionList,
    fromCloudStorageValidationAzureRegion = _require.fromCloudStorageValidationAzureRegion;

var awsRegionCodes = require('./constants/awsRegionCodes');

var gcpRegionCodes = require('./constants/gcpRegionCodes');
var gcpRegionCodeGroups = require('./constants/gcpRegionCodeGroups');

var wasabiRegionCodes = require('./constants/wasabiRegionCodes');

var azureRegionCodes = require('./constants/azureRegionCodes');

module.exports = {
    regionListByVendor: regionListByVendor,
    regionListForVendor: regionListForVendor,
    fromCloudStorageValidationAzureRegion: fromCloudStorageValidationAzureRegion,
    cloudStorageValidationAzureRegionList: cloudStorageValidationAzureRegionList,
    awsRegionCodes: awsRegionCodes,
    gcpRegionCodes: gcpRegionCodes,
    gcpRegionCodeGroups: gcpRegionCodeGroups,
    wasabiRegionCodes: wasabiRegionCodes,
    azureRegionCodes: azureRegionCodes
};